
import React from 'react';
import { Link } from 'react-router-dom';

const HeroSection: React.FC = () => {
  return (
    <section 
      className="relative min-h-screen flex items-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/f9288e60d056845434bbaa9885ffb1f7.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="relative z-10 max-w-4xl mx-auto text-center text-white">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
              The Future of Healthcare is <span className="text-teal-400">Virtual</span>
            </h1>
            <p className="text-xl md:text-2xl mb-8 text-gray-200">
              24-hour virtual primary care subscriptions and cutting-edge wellness treatments in Miami, Florida
            </p>
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-6">
              <Link
                to="/virtual-primary-care"
                className="bg-gradient-to-r from-teal-500 to-teal-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 text-center whitespace-nowrap cursor-pointer"
              >
                Start Virtual Care
              </Link>
              <Link
                to="/treatments"
                className="border-2 border-white text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:bg-white hover:text-gray-900 transition-all duration-300 text-center whitespace-nowrap cursor-pointer"
              >
                View Treatments
              </Link>
            </div>
          </div>
          <div className="hidden lg:block">
            {/* Image content handled by background */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
